import React from 'react';
import TeamsExplorePage from './teamsExplorePage';
import TeamsLayoutPage from './teamsLayoutPage';
import { useFinanceData } from '../../licenseAnalyticsPage/financePage';

interface FacilitiesPageProps {
  mode: string;
}

const TeamsPage: React.FC<FacilitiesPageProps> = React.memo(({ mode }) => {
  useFinanceData();

  return <>{mode === 'Dashboard' ? <TeamsLayoutPage /> : <TeamsExplorePage />}</>;
});

export default TeamsPage;
